// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".admin-inset-box{border:1px solid #dfdfee;border-radius:.125rem;background-color:#fff}.admin-inset-box:checked{background-color:#3182ce;position:relative}.admin-inset-box:checked:after{content:\"\";position:absolute;top:1px;left:4px;width:5px;height:10px;border-bottom:2px solid #fff;border-right:2px solid #fff;transform:rotate(45deg)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
